import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { connect, jwtAuthenticator, StringCodec } from 'nats.ws';
import { QRCodeCanvas } from 'qrcode.react';
import { PlayCircleFill, ArrowClockwise, QrCodeScan } from 'react-bootstrap-icons';
import { FaPhoneVolume } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
// import { Route, Routes, BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Home from './Home';
// import Login from './Login';
// import Layout from './Layout';

export default function App() {
  const [proofRequestURL, setProofRequestURL] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [deepLinkUrl, setDeepLinkUrl] = useState('');
  const [os, setOs] = useState('');

  const natsListener = useCallback(async (threadId, token) => {

    const sendToServer = async (params) => {
      try {
        const form = document.getElementById("loginForm");
        const usernameInput = form.querySelector("input[name='employeeId']");
        if (usernameInput) {
          usernameInput.value = params.employeeId;
        }

        if (os === "Other") {

          if (form) {
            console.log(form)
            form.submit();
          }
        } else {
          if (form) {
            console.log(form)
            form.submit();
          }
          // const baseUrl = 'https://uat.ecms.gov.bt/ECMS/cusLogin/authService/ndiLogindl.do';

          // const headers = {
          //   'username': params.username,
          // };

          // const requestOptions = {
          //   method: 'GET',
          //   headers: headers,
          // };

          // fetch(baseUrl, requestOptions)
          //   .then(response => {
          //     if (response.ok) {
          //       return response.text();
          //     } else {
          //       throw new Error('Request failed with status ' + response.status);
          //     }
          //   })
          //   .then(data => {
          //     if (form) {
          //       form.submit();
          //     }
          //   })
          //   .catch(error => {
          //     console.error('Error:', error);
          //     alert('An error occurred: ' + error.message + baseUrl);
          //   });

        }
      } catch (error) {
        setErrorMessage(error.message || "Error submitting data");
      }
    };


    try {

      const conn = await connect({
        servers: ["https://natsrcsc-client.bhutanndi.com"],
        // servers: ["wss://natsg2c.bhutanndi.com"],
        //servers: ["https://natsdemoclient.bhutanndi.com"],
         authenticator: jwtAuthenticator(token, new TextEncoder().encode('SUAMW7LEDJBGZDHLGMBXCEPQA4QSRGK4ULB4OFNXISHMWVIDCB56F3S7NI'))
        //authenticator: jwtAuthenticator(token, new TextEncoder().encode('SUAPXY7TJFUFE3IX3OEMSLE3JFZJ3FZZRSRSOGSG2ANDIFN77O2MIBHWUM'))
      });
      const sc = StringCodec();
      const s1 = conn.subscribe(threadId);

      for await (const m of s1) {
        const data = JSON.parse(sc.decode(m.data));
        if (data?.data?.verification_result === 'ProofValidated') {
          // "EID": empID,
          const { "ID Number": cid, "EID": empID } = data.data.requested_presentation.revealed_attrs;
          await sendToServer({ employeeId: cid[0].value });
          conn.close();

        } else {
          setErrorMessage('Your authorization request has been denied.')
        }
      }

    } catch (error) {
      console.error(error);
    }
  }, []);

  const detectDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iPhone/iOS";
    }
    return "Other";
  };


  const handleLoginWithNdi = useCallback(() => {
    setIsLoading(true);
    setErrorMessage('');
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Accept": "*/*"
    };

    axios.post(`${process.env.REACT_APP_BACKEND_URL}/authentication`, { headers })
      .then(response => {
        const { proofRequestURL, proofRequestThreadId, deepLinkURL } = response.data.data;
        const { access_token } = response.data;
        setProofRequestURL(proofRequestURL);
        setDeepLinkUrl(deepLinkURL);
        // console.log(deepLinkURL, "DEEPLINK")
        natsListener(proofRequestThreadId, access_token);
      })
      .catch(error => {
        setErrorMessage('Communication failed with server.')
      })
      .finally(() => setIsLoading(false));
  }, [natsListener]);

  useEffect(() => {

    setOs(detectDeviceType)
    // console.log(os)
    handleLoginWithNdi();
  }, [handleLoginWithNdi, os]);

  return (
    <>
      <header style={{ background: '#3e68b0 !important' }}>
        <div className='container-lg '>
          <span className="header-text text-center">Contact Number : +975-02-322319 / Email : info@ecms.gov.bt</span>
        </div>
      </header>

      <div className="container" id="loadMainPage">
        <div className="row mt-2">
          <div className="col d-flex justify-content-center">
            <div className="card mb-3" style={{ background: "#f8f8f8", width: "552px", minHeight: "623px" }}>
              <div className="card-body" style={{ marginLeft: '50px', marginRight: '50px' }}>
                <div className="form-group text-center">
                  <span style={{ fontWeight: "bold", color: "#A1A0A0", marginTop: "30px" }}>
                    Scan with <span style={{ color: "#5AC994" }}>Bhutan NDI</span> Wallet
                  </span>
                </div>

                {os !== "Other" &&
                  <div className='row justify-content-center' style={{ padding: '0 20px 0 20px' }}>
                    <a href={deepLinkUrl}
                      style={{ margin: "30px", background: "#5AC994", borderRadius: "10px", padding:"15px", fontWeight: "bold", color: "#ffffff", textAlign: "center", textDecoration: "none" }}>Open Bhutan NDI Wallet</a>

                    <div className="separator" style={{ color: "#A1A0A0" }}> OR </div>
                  </div>
                }

                <div className="form-group text-center" style={{ marginTop: "30px" }}>
                  {isLoading ? (
                    <div className='d-flex justify-content-center mt-3' style={{ minHeight: '260px' }}>
                      <div className="my-auto" role="status">
                        <div className="spinner-grow text-success" role="status">
                          <span className="sr-only"></span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    errorMessage ? (
                      <span className='text-danger font-weight-bold'>
                        {errorMessage} <br />
                        <img src={require("./assets/images/ecms.png")} alt="Logo" />
                        <br />
                        <span onClick={handleLoginWithNdi} style={{ textDecoration: "none", color: '#5AC994', cursor: 'pointer', fontWeight: 'bold' }}>
                          <ArrowClockwise style={{ fontWeight: 'bold' }} /> Retry
                        </span>
                      </span>
                    ) : (
                      <div>
                        <QRCodeCanvas
                          style={{ border: '2px solid rgb(90, 201, 148)', padding: '10px', borderRadius: '20px' }}
                          value={proofRequestURL}
                          size={260}

                          imageSettings={{
                            src: require("./assets/images/NDIlogobg.png"),
                            excavate: true,
                            height: 50,
                            width: 50
                          }} />
                      </div>
                    )
                  )}
                </div>
                <div className='form-group' style={{ marginTop: "30px" }}>

                  <div className='d-flex justify-content-center'>
                    <ol className='list-inline-item' style={{ color: "#A1A0A0", fontSize: "13px", fontWeight: '500' }}>
                      <li>Open Bhutan NDI Wallet on your phone.</li>
                      <li>Tap the Scan button
                        <span
                          className="text-center pull-right"
                          style={{
                            background: 'rgb(90, 201, 148)',
                            height: '20px',
                            width: '20px',
                            borderRadius: '50%',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            verticalAlign: 'middle',
                            marginLeft: '5px',
                            marginRight: '5px'
                          }}
                        >
                          <QrCodeScan color="white" size={12} />
                        </span>
                        located on the menu bar and scan QR code.</li>
                    </ol>
                  </div>
                </div>

                <form action={`/ECMS/cusLogin/authService/ndiLogin.do`} method='POST' id='loginForm'>
                  <input type='hidden' name='employeeId' />
                </form>

                <div className='d-flex justify-content-center' style={{ marginTop: "30px" }}>
                  <a href='https://www.youtube.com/@BhutanNDI' target='_blank' rel="noreferrer" style={{ border: "solid 2px #5AC994", borderRadius: "50px", padding: "10px 20px 10px 20px", color: "#5AC994", textAlign: "center", textDecoration: "none" }} >
                    Watch video guide <PlayCircleFill size={20} />
                  </a>
                </div>
                <div className='d-flex justify-content-center' style={{ marginTop: "30px", color: "#A1A0A0", textDecoration: 'none' }}>
                  <span>Don't Have the Bhutan NDI Wallet?</span>
                </div>
                <div className='d-flex justify-content-center'>
                  <p>
                    <a href="https://kiwhp.app.link/?t=" target='_blank' rel="noreferrer" style={{ color: "#5AC994", textDecoration: 'none' }}>Download Now!</a>
                  </p>
                </div>
                <div className="d-flex justify-content-center mb-4" style={{ marginTop: '10px' }}>
                  <a href="https://play.google.com/store/search?q=bhutan%20ndi&amp;c=apps&amp;hl=en_IN&amp;gl=US" target="_blank" rel="noopener noreferrer">
                    <img src={require("./assets/images/googleplay.png")} style={{ width: '99px', height: '30px' }} alt="Google Play Store" />
                  </a>
                  <a href="https://apps.apple.com/in/app/bhutan-ndi/id1645493166" target="_blank" rel="noopener noreferrer">
                    <img src={require("./assets/images/appstore.png")} style={{ width: '99px', height: '30px', marginLeft: '15px' }} alt="Apple App Store" /></a>
                </div>
                <div className='d-flex justify-content-center'>
                    <p  style={{ color: "#5AC994", fontWeight: '700' }}>Get Support</p>
                </div>
                <div className='d-flex justify-content-center'>
                    <p style={{ fontWeight: "600", fontSize: "14px"}}> <IoIosMail size={20} color='#5AC994'/> ndifeedback@dhi.bt <FaPhoneVolume size={13} color='#5AC994' style={{ marginLeft: "10px"}}/> 1199</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
